import Vue from "vue";

const Application = {
    namespaced: true,
    state: {
        needReturn: false,
        isDisabled: true,
        isHourDisabled: true
    },
    actions: {
        setNeedReturn(context, needReturn) {
            context.commit('SETNEEDRETURN', needReturn);
        },
        setIsHourDisabled(context, isHourDisabled) {
            context.commit('SETISHOURDISABLED', isHourDisabled);
        },
        setIsDisabled(context, isDisabled) {
            context.commit('SETISDISABLED', isDisabled);
        },
    },
    mutations: {
        SETNEEDRETURN: (state, needReturn) => {
            state.needReturn = needReturn;
        },
        SETISHOURDISABLED: (state, isHourDisabled) => {
            state.isHourDisabled = isHourDisabled;
        },
        SETISDISABLED: (state, isDisabled) => {
            state.isDisabled = isDisabled;
        }
    },
    getters: {
        needReturn: state => {
            return state.needReturn;
        },
        isHourDisabled: state => {
            return state.isHourDisabled;
        },
        isDisabled: state => {
            return state.isDisabled;
        }
    }
}

export default Application;